export const HttpMethod = {
  GET: 'get',
  POST: 'post',
}
